import React, { useState, useEffect } from "react";
import { getJSTDateString } from "@/shared/utils/date";

//type DateString = `${number}${number}${number}${number}-${number}${number}-${number}${number}`;

interface Props {
  id?: string;
  className?: string;
  title?: string;
  placeholder?: string;
  value?: string;
  initialValue?: string;
  onChange: (newValue: string) => void;
  labelEnable?: boolean;
  isDisabled?: boolean;
  maxDate?: string;
}

export const DateForm = (props: Props) => {
  const {
    id = "",
    className="",
    title = "",
    placeholder,
    value,
    initialValue,
    onChange,
    labelEnable = false,
    isDisabled,
    maxDate = getJSTDateString(),
  } = props;

  const [showValue, setShowValue] = useState(initialValue ?? "");
  useEffect(() => {
    const setValue = () => {
      if (value !== undefined) {
        setShowValue(value);
      }
    };
    setValue();
  }, [value]);

  // 入力値の変更イベントハンドラ
  const onChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setShowValue(newValue);
    onChange(newValue);
  };

  return (
    <>
      {labelEnable && <label htmlFor={id}>{title}</label>}
      <input
        id={id}
        className={className}
        type="date"
        value={showValue}
        placeholder={placeholder}
        onChange={onChangeInputValue}
        disabled={isDisabled}
        max={maxDate}
      />
    </>
  );
};
